// extracted by mini-css-extract-plugin
export default {"link":"JM-z","disabled":"KM-z"};